import React from "react"

interface Props extends React.ComponentPropsWithoutRef<"svg"> {
    size?: number | string
    style?: React.CSSProperties
    color?: string
    className?: string
}

export function InstagramFarFAIcon({ size = 16, color, style, className, ...others }: Props) {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="instagram"
            className={`svg-inline--fa fa-instagram fa-w-10 fa-fw ${className}`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
            color={color}
            style={{ width: size, height: size, ...style }}
            {...others}
        >
            <path
                fill="currentColor"
                d="M7 3.4375C9 3.4375 10.5938 5.0625 10.5938 7.03125C10.5938 9.03125 8.96875 10.625 7 10.625C5 10.625 3.40625 9 3.40625 7.03125C3.40625 5.03125 5.03125 3.4375 7 3.4375ZM7 4.6875C5.6875 4.71875 4.65625 5.75 4.65625 7.03125C4.6875 8.34375 5.71875 9.375 7 9.375C8.3125 9.34375 9.34375 8.3125 9.34375 7.03125C9.3125 5.71875 8.28125 4.6875 7 4.6875ZM9.90625 3.28125C9.90625 3.75 10.2812 4.125 10.75 4.125C11.2188 4.125 11.5938 3.75 11.5938 3.28125C11.5938 2.8125 11.2188 2.46875 10.75 2.46875C10.2812 2.46875 9.90625 2.8125 9.90625 3.28125ZM13.9688 4.15625C14.0312 5.3125 14.0312 8.75 13.9688 9.90625C13.9062 11.0312 13.6562 12.0312 12.8438 12.8438C12 13.6875 11.0312 13.9375 9.90625 13.9688C8.75 14.0625 5.28125 14.0625 4.125 13.9688C3 13.9375 2 13.6562 1.1875 12.8438C0.375 12.0312 0.09375 11.0312 0.0625 9.90625C0 8.75 0 5.28125 0.0625 4.125C0.125 3.03125 0.375 2.03125 1.1875 1.21875C2 0.375 3 0.125 4.125 0.0625C5.28125 0 8.75 0 9.90625 0.0625C11.0312 0.125 12 0.375 12.8438 1.21875C13.6562 2.03125 13.9062 3.03125 13.9688 4.15625ZM12.4688 11.1562C12.8438 10.25 12.75 8.0625 12.75 7.03125C12.75 6 12.8438 3.8125 12.4688 2.90625C12.2188 2.28125 11.75 1.8125 11.125 1.5625C10.2188 1.21875 8.03125 1.28125 7 1.28125C6 1.28125 3.8125 1.21875 2.875 1.5625C2.28125 1.8125 1.78125 2.28125 1.5625 2.90625C1.1875 3.8125 1.28125 6 1.28125 7.03125C1.28125 8.0625 1.1875 10.25 1.5625 11.1562C1.8125 11.7812 2.28125 12.25 2.875 12.5C3.8125 12.8438 6 12.7812 7 12.7812C8.03125 12.7812 10.2188 12.8438 11.125 12.5C11.75 12.25 12.2188 11.7812 12.4688 11.1562Z"
            />
        </svg>
    )
}
